module.exports = __webpack_public_path__ + "prod/1.42.2/img/arrange-two.41f05283.png";